import { render, staticRenderFns } from "./InfoModalDialog.vue?vue&type=template&id=070053e9"
import script from "./InfoModalDialog.vue?vue&type=script&lang=js"
export * from "./InfoModalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports